"use strict";
/**
 * Voicemail-PIN validation helpers.
 *
 * A PIN is 6 decimal digits. We reject the two low-entropy classes that
 * real users still try to set and telecom fraud attacks specifically
 * enumerate:
 *  - all same digit (000000, 111111, … 999999)
 *  - strictly sequential ascending or descending runs (123456, 987654,
 *    012345, 543210)
 *
 * We do NOT reject every 6-digit birthday, date, or combination lock —
 * that's a losing battle in a self-service wizard. The goal is to catch
 * the obvious defaults.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAllSameDigit = isAllSameDigit;
exports.isStrictlySequential = isStrictlySequential;
exports.describePinError = describePinError;
function isAllSameDigit(pin) {
    if (pin.length < 2)
        return false;
    const first = pin[0];
    return pin.split("").every((d) => d === first);
}
function isStrictlySequential(pin) {
    if (pin.length < 2)
        return false;
    const digits = pin.split("").map((d) => Number(d));
    if (digits.some((n) => Number.isNaN(n)))
        return false;
    const deltas = new Set();
    for (let i = 1; i < digits.length; i++) {
        deltas.add(digits[i] - digits[i - 1]);
    }
    // Ascending by 1 → {1}; descending by 1 → {-1}. Anything else = not a
    // simple run.
    return deltas.size === 1 && (deltas.has(1) || deltas.has(-1));
}
function describePinError(pin) {
    if (!/^\d{6}$/.test(pin))
        return "PIN must be exactly 6 digits.";
    if (isAllSameDigit(pin))
        return "PIN can't be the same digit six times.";
    if (isStrictlySequential(pin))
        return "PIN can't be a sequential run like 123456 or 987654.";
    return null;
}
